import { gql } from "@apollo/client";

export const SOLICITAR_CORRECCION = gql`
    mutation SolicitarCorreccion($idEvaluacion: Int!, $observacion: String!) {
        solicitarCorreccionRI(idEvaluacion: $idEvaluacion, observacion: $observacion) {
            idEvaluacion
        }
    }
`;